import { generateID } from 'utils/helpers';


const makeId = generateID('ssdq12FB', 'disclaimerWithAgeVerification');

export const IDS = {
  exitBtn: makeId('badge-exitBtn'),
  agreeBtn: makeId('badge-agreeBtn'),
};
